import type { Ref, DeepReadonly } from 'vue'

export function useRedirectFromIdToSlug({
  urlParamId,
  entity,
  redirect,
}: {
  urlParamId: string
  entity: Ref<DeepReadonly<{ url_slug: string | null }> | null>
  redirect: (url_slug: string) => void
}) {
  if (!+urlParamId) return

  watch(
    entity,
    e => {
      if (e?.url_slug) {
        redirect(e.url_slug)
      }
    },
    { immediate: true }
  )
}
